'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Trash2 = function Trash2(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 13 15' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'remove'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M1 3l1-1v10.997A.995.995 0 0 0 2.992 14h7.016c.542 0 .992-.451.992-1.003V2l1 1H1zm0-1h11v10.997C12 14.103 11.1 15 10.008 15H2.992C1.892 15 1 14.106 1 12.997V2z'
        }),
        _react2.default.createElement('path', { d: 'M9 2L8 3V1.5c0-.28-.221-.5-.5-.5h-2c-.275 0-.5.225-.5.5V3L4 2h5zm0 1H4V1.5C4 .672 4.674 0 5.5 0h2C8.328 0 9 .666 9 1.5V3zM4 6.5V11h1V6H4zM6 6.5V11h1V6H6zM8 6.5V11h1V6H8z'
        }),
        _react2.default.createElement('path', { d: 'M.5 3H13V2H0v1z' })
      )
    )
  );
};
/*eslint-enable */

exports.default = Trash2;
//# sourceMappingURL=Trash2.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Trash2.js